import React from 'react';

const FallbackServerError = () => {
  return <div>Error Page</div>;
};

export default FallbackServerError;
